<template>
  <div class="wrapper">

    <div>

      <dashboard-content>

      </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss">

</style>
<script>
  import TopNavbar from './TopNavbar.vue'
  import ContentFooter from './ContentFooter.vue'
  import DashboardContent from './Content.vue'
  
  export default {
    components: {
      TopNavbar,
      ContentFooter,
      DashboardContent,
    },
  }

</script>
